import _ from 'lodash';
import React, { Component } from 'react';

import Select from 'react-select';

import {
  getOptionValueForSelect,
  localizeProfile,
} from '../../util';

class TalentProfileSelect extends Component {

  state = {

  }

  getLabelLocalizationForProfile(profile){

    const {
      language,
      orgLocaliztions,
      appLocalizations,
    } = this.props;

    return localizeProfile({
      profileId: profile.id,
      orgLocaliztions,
      appLocalizations,
      language,
    }) || profile.label;
  }

  getTalentProfileOptions(){
    const { talentProfiles } = this.props;

    let talentProfileOptions = [{
      value: 'default',
      label: 'Default (All Profiles)'
    }];

    _.each(talentProfiles, profile => {
      talentProfileOptions.push({
        value: profile.id,
        label: this.getLabelLocalizationForProfile(profile)
      });
    });

    return talentProfileOptions;
  }

  render(){

    const { currentProfile } = this.props;

    return (
      <div
        className={`talent-profile-select-container`}
      >
        <Select
          classNamePrefix={'react-select'}
          className={`react-select-container talent-profile-select`}
          value={getOptionValueForSelect(this.getTalentProfileOptions(), currentProfile)}
          options={this.getTalentProfileOptions()}
          onChange={(option) => { this.props.changeProfile(option.value); }}
          isSearchable={true}
        />
      </div>
    )
  }
}
export default TalentProfileSelect;



// WEBPACK FOOTER //
// ./src/components/shared/talentProfileSelect.js